/**
 * Automatically imports all the modules and exports as a single module object
 */
const modules = {};

/* Require store files from the main store folder */
const storeModule = require.context(
    ".", // current directory
    false, // subdirectories
    /\.store\.js$/ // only .json
);

storeModule.keys().forEach((filename) => {
    const moduleName = filename.replace(/(\.\/|\.store\.js)/g, "");
    modules[moduleName] = storeModule(filename).default || storeModule(filename);
});

/* Require store files from the core folder */
const coreModule = require.context(
    "Core", // current directory
    true, // subdirectories
    /store\.[a-zA-Z0-9_]+\.js$/ // only .json
);

coreModule.keys().forEach((filename) => {
    const filename2 = filename.substring(filename.lastIndexOf("/") + 1);
    const moduleName = filename2.replace(/store\./g, "").replace(/.js/g, "");

    modules[moduleName] = coreModule(filename).default || coreModule(filename);
});

/* Require store files from the modules folder */
const subModule = require.context(
    "Modules", // current directory
    true, // subdirectories
    /store\.[a-zA-Z0-9_]+\.js$/ // only .json
);

subModule.keys().forEach((filename) => {
    const filename2 = filename.substring(filename.lastIndexOf("/") + 1);
    const moduleName = filename2.replace(/store\./g, "").replace(/.js/g, "");

    modules[moduleName] = subModule(filename).default || subModule(filename);
});

//console.log(modules);
export default modules;
